var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-row"},[_vm._v("\n    Empty HeaderButtons.vue\n    "),_c('router-view',{attrs:{"name":"header_buttons"}},[_vm._v("buttons")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }